import React from 'react';
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';
import toast from 'react-hot-toast';

import { auth } from '../../services/Firebase';
import { Text, FlexContainer } from '../../shared/Typhography';
import { useGlobalModalContext } from '../../context/GlobalModal';
import { Button, Input, Modal } from '../../shared/Components';
import { useForm } from '../../hooks';
import { ChangePasswordField, changePasswordSchema } from '../../validations/changePassword';
import { strings } from '../../strings';

interface ChangePasswordInputs {
  [ChangePasswordField.CURRENT_PASSWORD]: string;
  [ChangePasswordField.NEW_PASSWORD]: string;
  [ChangePasswordField.CONFIRM_NEW_PASSWORD]: string;
}

const UpdatePasswordModal = () => {
  const { hideModal, store } = useGlobalModalContext();
  const { modalProps } = store || {};
  const { title } = modalProps;
  const user = auth.currentUser || ({} as any);

  const {
    handleSubmit,
    control,
    setError,
    reset,
    formState: { errors },
  } = useForm<ChangePasswordInputs>({
    schema: changePasswordSchema,
  });

  const submit = handleSubmit(async (data) => {
    try {
      //We need to reauthenticate user because token expired and cant update password because user need to be recently logged in.
      const credential = EmailAuthProvider.credential(user.email, data.currentPassword); //Hardcoded password
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, data.newPassword);
      toast.success(strings.toastSuccessfullyChangedPassword);
      hideModal();
      reset();
    } catch (error: any) {
      switch (error.code) {
        case 'auth/wrong-password':
          setError(ChangePasswordField.CURRENT_PASSWORD, {
            type: 'custom',
            message: strings.currentPasswordIncorrect,
          });
          break;
        default:
          toast.error(strings.toastNotificationSomethingWrong);
          break;
      }
    }
  });

  return (
    <Modal padding="20px" height={350} width={460} onRequestClose={hideModal}>
      <Text weight="bold" size={1.2}>
        {title}
      </Text>
      <FlexContainer justifyContent="space-around" height="100%" flexDirection="column">
        <Input
          type="password"
          placeholder={strings.currentPassword}
          name={ChangePasswordField.CURRENT_PASSWORD}
          control={control}
          error={errors[ChangePasswordField.CURRENT_PASSWORD]}
          width="320px"
        />
        <Input
          type="password"
          placeholder={strings.newPassword}
          name={ChangePasswordField.NEW_PASSWORD}
          control={control}
          error={errors[ChangePasswordField.NEW_PASSWORD]}
          width="320px"
        />
        <Input
          type="password"
          placeholder={strings.confirmNewPassword}
          name={ChangePasswordField.CONFIRM_NEW_PASSWORD}
          control={control}
          error={errors[ChangePasswordField.CONFIRM_NEW_PASSWORD]}
          width="320px"
        />
      </FlexContainer>
      <FlexContainer gap="1rem">
        <Button onClick={hideModal} variant="link">
          Cancel
        </Button>
        <Button onClick={submit} height={40} width={130}>
          Submit
        </Button>
      </FlexContainer>
    </Modal>
  );
};

export default UpdatePasswordModal;
